import React from 'react';

import logo from '../../../images/loading.gif';

export const RsdLoader = () => <img src={ logo } alt="loading..." />;
